import {defineStore} from 'pinia';
import {ref, useFeatureFlag, useLogger} from '#imports';
import type {FeatureContext} from '~/store/featureTypes';
import {FeatureFlags} from '~/store/featureTypes';

export const useFeatureContextStore = defineStore('features', () => {
    const features = ref<FeatureContext>({} as FeatureContext);
    const {fetchFeatureFlags} = useFeatureFlag();
    const logger = useLogger();

    async function loadFeatureContext(): Promise<void> {
        logger.debug('Loading feature flags');
        features.value = await fetchFeatureFlags([...FeatureFlags]);
    }

    return {
        features,
        loadFeatureContext,
    };
});
